import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { ISimulationInput } from 'components/generics/Interface/Simulation/ISimulationInput';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { lastSimulate } from 'services/API/Simulation';
import useAuth from 'providers/Auth/useAuth';
import { IUser, RolesNames } from 'components/generics/Interface/Api/Response/User/IUser';
import { useTranslation } from 'react-i18next';

const SelectSimuOtherUser = ({
  isSimulationContextUpdated,
  updateSimulationParams,
  exploitationId,
  setHasExistingSimulation,
}) => {
  const { user } = useAuth();
  const [otherUsersList, setOtherUserList] = useState(null);
  const [selectedSimu, setSelectedSimu] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    if (exploitationId && isSimulationContextUpdated) {
      lastSimulate(exploitationId)
        .then((res) => {
          const currentUserLastSimulate = res.data.data.find((simu) => simu.user.id === user.id);
          if (currentUserLastSimulate) {
            updateSimulationParams(currentUserLastSimulate.simulation);
          } else {
            setHasExistingSimulation(false);
          }
          const currentUserLastSimulateId = currentUserLastSimulate?.id || '';
          setSelectedSimu(currentUserLastSimulateId);
          setOtherUserList(res.data.data);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        });
    }
  }, [isSimulationContextUpdated]);

  const handleSimuChange = (event) => {
    setSelectedSimu(Number(event.target.value));
    const simuParams = otherUsersList?.find((simu) => simu.id === event.target.value);
    updateSimulationParams(simuParams?.simulation);
  };

  return user?.role === RolesNames.SUPER_ADMIN ? (
    <FormControl size="small" sx={{ minWidth: 200, maxWidth: 250 }}>
      <InputLabel id="select_other_user_simu_label">{t('label.chooseUser')}</InputLabel>
      <Select
        labelId="select_other_user_simu_label"
        autoWidth
        label={t('label.chooseUser')}
        id="select_other_user_simu"
        name="select_other_user_simu"
        value={selectedSimu}
        onChange={(e) => handleSimuChange(e)}
      >
        {otherUsersList?.map((simulationData) => (
          <MenuItem key={simulationData.id} value={simulationData.id}>
            {simulationData.user.firstname + ' ' + simulationData.user.lastname}
          </MenuItem>
        ))}
        {otherUsersList?.length === 0 && (
          <MenuItem key={0} value={0} disabled>
            {t('message.noSimulationAvailable')}
          </MenuItem>
        )}
      </Select>
    </FormControl>
  ) : (
    <></>
  );
};

export default SelectSimuOtherUser;
